import { Utils } from './module/utils';

// -----------------------------------------------
// スクロールアニメーション定義
// -----------------------------------------------
// フェードイン
const fadeIn = {
  set: { opacity: 0 },
  to: { opacity: 1, duration: 1.4, delay: 0, ease: 'power2.easeIn' },
};
// ふわっと上がる
const fadeInUp = {
  set: { y: '50px', opacity: 0 },
  to: { y: '0', opacity: 1, duration: 0.3, delay: 0, ease: 'power3.easeIn' },
};
const animationMap = new Map();
animationMap.set('fadeIn', fadeIn);
animationMap.set('fadeInUp', fadeInUp);

// -----------------------------------------------
// スクロールアニメーション初期化
// -----------------------------------------------
function initScrollAnimation(selector, options = { once: true }) {
  const targets = document.querySelectorAll(selector);

  targets.forEach((el) => {
    const anime = Object.assign({}, animationMap.get(el.dataset.anime));

    // -------------------------
    // set（初期設定）
    // -------------------------
    // setが配列でない場合は、配列に変換する
    if (!Array.isArray(anime.set)) {
      anime.set = new Array(anime.set);
    }
    anime.set.forEach((set) => {
      let target = el;
      if (set.target) {
        target = set.target;
        delete set.target;
      }
      gsap.set(target, set);
    });

    // -------------------------
    // to（アニメーション）
    // -------------------------
    // toが配列でない場合は、配列に変換する
    if (!Array.isArray(anime.to)) {
      anime.to = new Array(anime.to);
    }

    // scrollTrigger設定
    let st = { scrollTrigger: { trigger: el, start: 'top+=150 bottom' } };
    if (el.dataset.start) {
      st.scrollTrigger.start = el.dataset.start;
    }

    // let st = { scrollTrigger: { trigger: el, markers: true, start: 'top+=50 bottom' } };
    if (!options.once) {
      st.scrollTrigger.toggleActions = 'play reset play reset';
    }

    const tl = gsap.timeline(st);
    anime.to.forEach((to, index) => {
      // 配列の先頭要素だけ、data属性から渡された時間を設定する
      if (index === 0) {
        // data属性 > 定数 の優先度でセットする。全てなしならば0とする
        to.duration = el.dataset.duration || to.duration || 0;
        to.delay = el.dataset.delay || to.delay || 0;
      }

      let target = el;
      if (to.target) {
        target = to.target;
        delete to.target;
      }
      if (to.position || to.position === 0) {
        const position = to.position;
        delete to.position;
        tl.to(target, to, position);
        console.log(position);
      } else {
        tl.to(target, to);
      }
    });
  });
}

// -----------------------------------------------
// スクロール無効
// -----------------------------------------------
function preventDefaultEvent(event) {
  event.preventDefault();
}
function disableScroll() {
  document.querySelector('body').classList.add('disable-scroll');
  document.addEventListener('touchmove', preventDefaultEvent, { passive: false });
}

// -----------------------------------------------
// スクロール有効
// -----------------------------------------------
function enableScroll() {
  document.querySelector('body').classList.remove('disable-scroll');
  document.removeEventListener('touchmove', preventDefaultEvent, { passive: false });
}

// -----------------------------------------------
// ハンバーガーを開閉する
// -----------------------------------------------
function toggleHamburger(target, hamburgerTweenTimeline) {
  const isOpen = target.classList.toggle('is-open');

  const header = target.closest('.js-header');
  const drawer = header.querySelector('.js-drawer');
  header.classList.toggle('is-open');
  drawer.classList.toggle('is-open');

  if (isOpen) {
    disableScroll();
    hamburgerTweenTimeline.play(0);
    playDrawerOpenTween(drawer);
  } else {
    hamburgerTweenTimeline.reverse();
    enableScroll();
  }
}

// -----------------------------------------------
// ハンバーガーを強制的に閉じる
// -----------------------------------------------
function forceCloseHamburger(mobileAnime) {
  if (!mobileAnime.header.classList.contains('is-open')) {
    // ハンバーガーが開いてなければ何もしない
    return;
  }

  if (mobileAnime.openTweenTl.isActive) {
    // ハンバーガーオープンアニメ実行中だったら停止する
    mobileAnime.openTweenTl.kill();
  }

  // ハンバーガーを閉じている状態に初期化する
  mobileAnime.header.classList.remove('is-open');
  gsap.set(mobileAnime.mobileItems, { autoAlpha: 0, y: 10 });
  gsap.set(mobileAnime.mobileOverlay, { y: '-100%' });
  gsap.set(mobileAnime.header, { height: '100px' });
}

// -----------------------------------------------
// ドロワーオープンアニメ再生
// -----------------------------------------------
function playDrawerOpenTween(drawer) {
  const drawerNavItems = drawer.querySelectorAll('.js-drawer-nav-item');

  gsap.set(drawerNavItems, { autoAlpha: 0, x: 20, y: -20 });
  const tl = gsap.timeline();
  tl.to(drawerNavItems, { autoAlpha: 1, x: 0, y: 0, stagger: 0.05, duration: 0.15, ease: 'linear' });
}

// -----------------------------------------------
// ハンバーガーアニメーションタイムライン生成
// -----------------------------------------------
function createHamburgerTweenTimeline(target) {
  const line1 = target.querySelector('.hamburger__line span:nth-child(1)');
  const line2 = target.querySelector('.hamburger__line span:nth-child(2)');
  const tl = gsap.timeline({ paused: true });
  const y1 = Utils.isPc() ? 18 : 8;
  const y2 = Utils.isPc() ? 24 : 10;
  const y3 = Utils.isPc() ? 6 : 2;

  tl.to(line1, { y: y1, duration: 0.2, ease: 'linear' }, 0);
  tl.to(line1, { y: y2, rotate: '-45deg', duration: 0.2, ease: 'power1.inOut' }, 0.2);
  tl.to(line2, { y: y3, rotate: '45deg', duration: 0.2, ease: 'power1.inOut' }, 0.2);
  return tl;
}

// -----------------------------------------------
// ローディングアニメーションタイムライン生成
// -----------------------------------------------
function createLoadingTweenTimeline() {
  const loading = document.querySelector('.js-loading-anime');
  const logo = document.querySelector('.js-loading-anime .top-loading__logo');
  const logoChars = document.querySelectorAll('.js-loading-anime .top-loading__logo-char');
  const overlay1 = document.querySelector('.js-loading-anime .top-loading__overlay-1');
  const overlay2 = document.querySelector('.js-loading-anime .top-loading__overlay-2');
  const fvClipPathItems = document.querySelectorAll('.js-fv-clip-path-anime');
  const fvClipPathItemsFilter = document.querySelectorAll('.js-fv-clip-path-anime span');

  const tl = gsap.timeline({ paused: true });
  tl.add(disableScroll);
  tl.to(logoChars, { opacity: 1, duration: 0.45, stagger: 0.02, ease: 'power1.in' }, '+=0.2');
  tl.addPause(); // 一時停止
  // ★以下のアニメーションはwindowロード後に行う
  tl.to(overlay1, { x: '120%', duration: 0.8, ease: 'power1.out' });
  tl.to(overlay2, { x: '120%', duration: 0.6, ease: 'power1.in' }, '-=0.1');
  tl.add(enableScroll);
  tl.to(logo, { opacity: 0, duration: 0.4, ease: 'power1.out' }, '-=0.4');
  tl.to(loading, { autoAlpha: 0 });
  tl.to(fvClipPathItems, { clipPath: 'inset(0% 0% 0% 0%)', stagger: 0.4, duration: 0.4, ease: 'power1.out' }, '-=0.3');
  tl.to(fvClipPathItemsFilter, { clipPath: 'inset(0 0% 0 100%)', stagger: 0.4, duration: 0.2, ease: 'power1.out' }, '-=0.95');
  return tl;
}

// -----------------------------------------------
// スライダー初期化
// -----------------------------------------------
function initSwiper() {
  // スライダー
  if (document.querySelector('.js-catalog-slider')) {
    const voiceSwiper = new Swiper('.js-catalog-slider', {
      width: 262,
      spaceBetween: 36,
      // slidesPerView: 3,
      // speed: 1000,
      navigation: {
        prevEl: '.catalog-slider__prev',
        nextEl: '.catalog-slider__next',
      },
      // 自動再生
      // autoplay: {
      //   // 流れるように動かす
      //   delay: 0,
      // },
      breakpoints: {
        // 960px以上の場合
        960: {
          width: 561,
          spaceBetween: 70,
        },
      },
    });
  }
}

// -----------------------------------------------
// スライダー初期化
// -----------------------------------------------
function splitAndShortenText(selector, maxLength) {
  let elements = document.querySelectorAll(selector);

  elements.forEach((element) => {
    // 文字数を制限して、spanで囲う
    let parts = element.innerHTML.split('<br>');

    if (parts.length == 1) {
      return;
    }

    let wrappedParts = parts.map((part) => {
      // 文字数を制限する
      if (part.length > maxLength) {
        part = part.substr(0, maxLength) + ' …';
      }

      return `<span>${part}</span>`;
    });

    element.outerHTML = wrappedParts.join('<br>');
  });
}

function addSpanToElements(selector) {
  let elements = document.querySelectorAll(selector);

  elements.forEach((element) => {
    let newSpan = document.createElement('span');
    newSpan.className = 'utils-filter-theme';
    element.appendChild(newSpan);
  });
}

// ローディングアニメーションタイムライン生成
const loadingTweenTimeline = Utils.isPage('top') && createLoadingTweenTimeline();

//-------------------------------------------
// DOMロードイベント
//-------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  if (Utils.isPage('top')) {
    // ローディングアニメーション開始
    loadingTweenTimeline.play();
  }

  Utils.switchViewport(376, 390);

  // テキスト文字数制限
  let maxLength;
  if (Utils.isPage('archive-daimon-catalog')) {
    // ダイモンカタログはPCもスマホも11文字まで
    maxLength = Utils.isPc() ? 11 : 11;
  } else {
    maxLength = Utils.isPc() ? 10 : 10;
  }
  splitAndShortenText('.js-catalog-title > span', maxLength);

  //-------------------------------------------
  // イベント
  //-------------------------------------------
  // #から始まるURLクリック
  if (document.querySelector('a[href*="#"]')) {
    document.querySelectorAll('a[href*="#"]').forEach((el) => {
      if (el.closest('#ez-toc-container')) {
        // 目次プラグインのアンカーの場合は何もしないで抜ける
        return false;
      }

      el.addEventListener('click', (event) => {
        if (Utils.isInPageLink(event)) {
          // ページ内リンクの場合、親イベントを破棄し、スムーズスクロールで移動
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          // forceCloseHamburger();
          Utils.movePosition(event.currentTarget);
        }
      });
    });
  }

  // ハンバーガークリック
  if (document.querySelector('.js-hamburger')) {
    document.querySelectorAll('.js-hamburger').forEach((el) => {
      const hamburgerTweenTimeline = createHamburgerTweenTimeline(el);
      el.addEventListener('click', (event) => toggleHamburger(event.target, hamburgerTweenTimeline));
    });
  }

  // アコーディオンクリック
  if (document.querySelector('.js-accordion .js-accordion-button')) {
    document.querySelectorAll('.js-accordion .js-accordion-button').forEach((el) => {
      el.addEventListener('click', (event) => {
        // クリックされた要素がaタグだったら何もしないで抜ける
        if (event.target.tagName.toLowerCase() === 'a') {
          return true;
        }

        event.preventDefault();
        event.target.classList.toggle('is-open');
        const target = event.target.querySelector('.js-accordion-target');
        jQuery(target).slideToggle(500);

        // アコーディオンの開閉で高さが変化するので、トリガー位置をリフレッシュする
        // (アコーディオン動作を待ってから処理する)
        setTimeout(() => {
          ScrollTrigger.refresh();
        }, 500);
      });
    });
  }

  // ヘッダーアニメーション
  if (document.querySelector('.js-fix-header')) {
    const header = document.querySelector('.js-fix-header');
    ScrollTrigger.create({ trigger: 'body', start: 'top+=250 top', end: 'bottom+=100000 bottom', markers: false, toggleClass: { targets: header, className: 'is-show' } });
  }

  // フッターに入ったら背景色を変更し、背景画像を表示する
  if (document.querySelector('.js-clip-path-anime-items')) {
    // アニメーション用のspan追加
    addSpanToElements('.js-clip-path-anime-item > span');

    // クリップパスアニメーション定義
    const playClipPathTween = (el) => {
      const ClipPathItems1 = el.querySelectorAll('.js-clip-path-anime-item[order="1"] > span');
      const ClipPathItemsFilter1 = el.querySelectorAll('.js-clip-path-anime-item[order="1"] > span > span');
      const ClipPathItems2 = el.querySelectorAll('.js-clip-path-anime-item[order="2"] > span');
      const ClipPathItemsFilter2 = el.querySelectorAll('.js-clip-path-anime-item[order="2"] > span > span');
      const tl = gsap.timeline();
      gsap.set(ClipPathItems1, { clipPath: 'inset(0% 100% 0% 0%)' });
      gsap.set(ClipPathItems2, { clipPath: 'inset(0% 100% 0% 0%)' });
      tl.to(ClipPathItems1, { clipPath: 'inset(0% 0% 0% 0%)', stagger: 0.4, duration: 0.4, ease: 'power1.out' }, 0.5);
      tl.to(ClipPathItemsFilter1, { clipPath: 'inset(0% 0% 0% 100%)', stagger: 0.4, duration: 0.2, ease: 'power1.out' }, 0.595);
      if (ClipPathItems2) {
        tl.to(ClipPathItems2, { clipPath: 'inset(0% 0% 0% 0%)', duration: 0.4, ease: 'power1.out' }, 0.85);
        tl.to(ClipPathItemsFilter2, { clipPath: 'inset(0% 0% 0% 100%)', duration: 0.2, ease: 'power1.out' }, 1.15);
      }
    };

    const clipPathItemsAll = document.querySelectorAll('.js-clip-path-anime-items');
    clipPathItemsAll.forEach((el) => {
      ScrollTrigger.create({ trigger: el, start: 'center bottom', end: 'center bottom', markers: false, onEnter: playClipPathTween.bind(null, el), once: true });
    });
  }

  // トップへ戻るアニメーション
  // if (document.querySelector('.js-to-top')) {
  //   const toTop = document.querySelector('.js-to-top');
  //   ScrollTrigger.create({ trigger: 'body', start: 'top+=300 top', end: 'bottom+=100000 bottom', markers: false, toggleClass: { targets: toTop, className: 'is-show' } });
  // }

  // スクロールアニメーション
  if (document.querySelector('.js-scroll-anime')) {
    initScrollAnimation('.js-scroll-anime');
  }

  // if (Utils.isMobile()) {
  //   Utils.setHeightFromWindowHight('.js-height-setting')
  // }

  initSwiper();
});

//-------------------------------------------
// Windowロードイベント
//-------------------------------------------
window.addEventListener('load', () => {
  // トップページローディングアニメーション（再開）
  if (Utils.isPage('top')) {

    // ローディングアニメーションが「一時停止中」or「3秒経過」だったら再開する
    let timeout = 3000;
    const interval = 100;
    const checkTimeline = setInterval(() => {
      timeout -= interval;
      if (loadingTweenTimeline.paused() || timeout <= 0) {
        loadingTweenTimeline.resume();
        clearInterval(checkTimeline);
      }
    }, interval);
  }

  // aboutページFVアニメーション
  if (Utils.isPage('about') && document.querySelector('.js-about-fv-anime')) {
    const fvAnimeItems = document.querySelectorAll('.js-about-fv-anime-item');
    const tl = gsap.timeline();
    tl.to(fvAnimeItems, { opacity: 1, stagger: 0.2, duration: 1.2, ease: 'power2.in' });
  }

  // 投稿の目次が閉じている場合はtoc_closeクラスを追加する
  // ※Easy table of contentsプラグインのバグ対応
  if (document.querySelector('.ez-toc-list.ez-toc-list-level-1')) {
    const tocList = document.querySelector('.ez-toc-list.ez-toc-list-level-1');
    if (tocList.style.display === 'none') {
      document.querySelector('.ez-toc-container-direction').classList.add('toc_close');
    }
  }
});
